import React, { useState, useEffect } from "react";
import "../CSS/NaviWindow.css";
import facebook from "../Assests/Images/facebook.png";
import twitter from "../Assests/Images/twitter.png";
import instagram from "../Assests/Images/instagram.png";
import youtube from "../Assests/Images/youtube.png";
import linkedin from "../Assests/Images/linkedin.png";
import { Link, useNavigate } from "react-router-dom";
import FeatureFlag from "../Fileconfigsettings/FeatureFlag";
import { getAuth, signOut, onAuthStateChanged } from "firebase/auth";
// eslint-disable-next-line
const socialMediaLinks = [
  { href: "https://www.facebook.com/BlogWiki", src: facebook, alt: "Facebook" },
  { href: "https://www.twitter.com/BlogWiki_in", src: twitter, alt: "Twitter" },
  { href: "https://www.instagram.com/blogwiki.in/", src: instagram, alt: "Instagram" },
  { href: "https://www.youtube.com/@BlogWiki_in", src: youtube, alt: "YouTube" },
  { href: "https://www.linkedin.com/company/blogwiki/", src: linkedin, alt: "LinkedIn" },
];

const NavigationBar = () => {
  const Auth = getAuth();
  const navigate = useNavigate();
  const SubscribeFeature = FeatureFlag("FeatureFlagOn");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [username, setUsername] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem("IsLoggedIn") === "true");
  const [showProfileOptions, setShowProfileOptions] = useState(false);
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(Auth, (user) => {
      if (user) {
        setIsLoggedIn(true);
        setUsername(localStorage.getItem("UserName"));
      } else {
        setIsLoggedIn(false);
      }
    });

    return unsubscribe;
  }, [Auth]);

  useEffect(() => {
    document.body.classList.toggle("menu-open", isMenuOpen);
  }, [isMenuOpen]);

  const handleProfileClick = () => {
    setShowProfileOptions(!showProfileOptions);
  };

  const SearchInput = (event) => {
    setSearchInput(event.target.value);
  };

  const SearchSubmit = async () => {
    navigate(`/search?q=${searchInput}`);
  };

  const OnEnter = async (event) => {
    if (event.key === 'Enter') {
      SearchSubmit();
    }
  };

  const handleLogout = () => {
    signOut(Auth);
    navigate("/");
  };

  const toggleMenu = () => {
    setIsMenuOpen((prevState) => !prevState);
  };

  const navigationLinks = [
    { Linkname: "Home", PageLink: "/" },
    { Linkname: "News", PageLink: "/News" },
    { Linkname: "Tech", PageLink: "/Tech" },
    { Linkname: "Gadgets", PageLink: "/Gadgets" },
    { Linkname: "Weather", PageLink: "/Comingsoon" },
    { Linkname: "About", PageLink: "/About" },
    { Linkname: "Contact", PageLink: "/Contact" },
    { Linkname: "Services", PageLink: "/Comingsoon" }
  ];

  return (
    <div className="Head-Wrapper">
      <div className="Headear">
        <div className="Logo">
          <h2>BlogWiki</h2>
          <p>Inspired by Information</p>
        </div>
        <div className="line"></div>
      </div>
      <div>
        <div id="menu" className="menu">
        <div className="profile-options">
            {!isLoggedIn ? (
              <Link to="/LoginSignup" className="Login-btn Link">
                Login/Signup
              </Link>
            ) : (
              <>
                <div className="UserProfileWrap" onClick={handleProfileClick}>
                  <p>{username ? username.charAt(0) : ""}</p>
                </div>
                {showProfileOptions && (
                  <ul className="ProfileOption">
                    <li key="account" className="Dropmain">
                      <Link className="dropdown-item Account" to="/profile">
                        Account
                      </Link>
                    </li>
                    <hr></hr>
                    <li key="logout">
                      <button className="dropdown-item Logouticon" onClick={handleLogout}>
                        Logout
                      </button>
                    </li>
                  </ul>
                )}
              </>
            )}
          </div>
          {navigationLinks.map(({ Linkname, PageLink }) => (
            <span key={Linkname} className="nav-item">
              <Link className="Link" to={Linkname === "Home" ? "/" : PageLink}>
                {Linkname}
              </Link>
            </span>
          ))}
        </div>
      </div>
      {SubscribeFeature && (
            <div className="search">
              <input
                id="search"
                className="searchinput"
                type="search"
                placeholder="  Search...."
                onChange={SearchInput}
                onKeyDown={OnEnter}
              />
              <div className="SearchIcon" onClick={SearchSubmit}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="white"
                  className="bi bi-search"
                  viewBox="0 0 16 16"
                >
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                </svg>
              </div>
            </div>
          )}
      <div className="MobileNav">
        <div
          id="btn1"
          className="btn"
          onClick={toggleMenu}
          style={{ display: isMenuOpen ? "none" : "block" }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 512">
            <path
              fill="white"
              d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
            />
          </svg>
        </div>
        <div
          id="btn2"
          className="btn-2"
          onClick={toggleMenu}
          style={{ display: isMenuOpen ? "block" : "none" }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
            <path
              fill="white"
              d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default NavigationBar;
